<template>
  <div>
    <div class="app-head">
      <div class="title">{{ $store.state.sys.title }}</div>
      <div class="menu">
        <div class="menu-item" :class="{ active: key == '/orders' }" @click="menuClick('orders')">
          订单列表
        </div>
        <div class="menu-item" :class="{ active: key == '/refundorders' }" @click="menuClick('refundorders')">
          售后列表
        </div>
        <div class="menu-item" @click="onSync">同步订单</div>
      </div>
      <div class="action">
        <div></div>
        <div></div>
        <!-- <div class="logo">
          <el-image :src="mallInfo.logo"></el-image>
        </div> -->
        <div class="user-info">
          <el-popover placement="bottom-end" trigger="click">
            <div class="user-info-box">
              <div class="user-info-item text-hidden">
                店铺名：<span :title="mallInfo.mallName">{{ mallInfo.mallName }}</span>
              </div>
              <div class="user-info-item text-hidden">
                店铺秘钥：<span id="key" :title="mallInfo.secretKey" @mouseover="onSelectText">{{ mallInfo.secretKey }}</span>
              </div>
              <div class="footer">
                <div class="btn" @click="changePwd">更改密码</div>
                <div class="btn" @click="logout">退出账号</div>
              </div>
            </div>
            <div slot="reference" class="text-hidden">
              {{ mallInfo.mallName }}
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews" :exclude="exclude">
          <router-view v-if="refresh" :key="key" />
        </keep-alive>
      </transition>
    </section>
    <el-dialog title="请选择同步日期" :visible.sync="showSync" width="460px">
      <el-form :model="syncForm">
        <el-form-item label="开始日期" label-width="80px">
          <el-date-picker v-model="syncForm.startTime" :picker-options="startTimeOptions" type="date"
            value-format="yyyy-MM-dd" placeholder="选择日期" :clearable="false" />
        </el-form-item>
        <el-form-item label="结束日期" label-width="80px">
          <el-date-picker v-model="syncForm.endTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
            :clearable="false" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSync = false">取 消</el-button>
        <el-button type="primary" @click="syncOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改用户密码" :visible.sync="showPwd" width="460px" @closed="onClosedPwd">
      <el-form ref="pwdForm" :model="pwdForm" :rules="pwdRules">
        <el-form-item label="用户名" label-width="80px">
          <el-input v-model="pwdForm.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPwd" label-width="80px">
          <el-input show-password v-model.trim="pwdForm.newPwd" placeholder="账号默认密码为 000000，建议修改新密码。" />
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPwd" label-width="80px">
          <el-input show-password v-model.trim="pwdForm.confirmPwd" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPwd = false">取 消</el-button>
        <el-button type="primary" @click="savePwd">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AppMain",
  data() {
    let validator = (rule, value, callback) => {
      if (this.pwdForm.newPwd == "" || this.pwdForm.confirmPwd == "") {
        callback();
      }
      if (this.pwdForm.newPwd != this.pwdForm.confirmPwd) {
        callback("密码不一致");
      } else {
        callback();
      }
    };
    let day90 = this.$dayjs(new Date().toDateString()).add(-89, "day").valueOf();
    return {
      userApi: require("@/api/ks/user").default,
      orderApi: require("@/api/ks/order").default,
      syncLoading: false,
      showSync: false,
      refresh: true,
      exclude: null,
      showMall: false,
      syncForm: {
        startTime: this.$commonJs.getToday(),
        endTime: this.$commonJs.getToday(),
      },
      startTimeOptions: {
        disabledDate(value) {
          return value.getTime() < day90;
        },
      },
      showPwd: false,
      pwdForm: {
        userId: null,
        userName: "",
        newPwd: "",
        confirmPwd: ""
      },
      pwdRules: {
        newPwd: [
          { required: true, message: "新密码不能为空" },
          // { validator: this.$commonJs.validateRules.validPwd },
          { validator: validator },
        ],
        confirmPwd: [
          { required: true, message: "确认密码不能为空" },
          { validator: validator },
        ],
      }
    };
  },
  computed: {
    cachedViews() {
      return this.$store.state.tags.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    mallInfo() {
      var data = {};
      var user_info = localStorage.getItem("user-info");
      if (user_info) {
        data = { ...data, ...JSON.parse(user_info) };
      }
      console.log("mallInfo", data);
      return data;
    },
  },
  methods: {
    refreshView(name) {
      //隐藏组件
      this.refresh = false;
      //增加排除
      this.exclude = name;
      this.$nextTick((_) => {
        //删除排除
        this.exclude = null;
        //显示组件
        this.refresh = true;
      });
    },
    menuClick(url) {
      this.$router.push(url);
    },
    onSelectText(event) {
      // 获取一个Selection对象
      const selection = window.getSelection();
      // 先清空一下以选择的内容
      selection?.removeAllRanges();
      // 创建一个range对象
      const range = document.createRange();
      // 让range对象包含一个node的内容
      range.selectNodeContents(event.target);
      // 向selection中添加一个区域（range）
      selection?.addRange(range);
    },
    changePwd() {
      this.pwdForm.userId = this.mallInfo.userId;
      this.pwdForm.userName = this.mallInfo.userName;
      this.showPwd = true;
    },
    savePwd() {
      this.$refs.pwdForm.validate(valid => {
        if (!valid) return false;

        this.userApi.savePwd(this.pwdForm).then(res => {
          this.$message.success("保存成功");
          this.showPwd = false;
        }).catch(err => {

        })
      })
    },
    onClosedPwd() {
      // this.pwdForm.userId = "";
      // this.pwdForm.userName = "";
      // this.pwdForm.newPwd = "";
      // this.pwdForm.confirmPwd = "";
      this.$refs.pwdForm.resetFields();
    },
    async logout() {
      await this.$store.dispatch("logout").then((res) => {
        this.$store.dispatch("clearStorage");
        this.$router.push("/login");
      });
    },
    onSync() {
      this.showSync = true;
      // this.$confirm("是否确定进行数据同步操作？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     // console.log("确定")
      //     this.syncOrder();
      //   })
      //   .catch(() => {
      //     console.log("取消");
      //   });
    },
    syncOrder() {
      if (this.syncForm.endTime < this.syncForm.startTime) {
        this.$message.warning("结束时间不能小于开始时间")
        return;
      }
      this.syncLoading = this.$loading({
        lock: true,
        text: "正在同步...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.orderApi.sync(this.syncForm).then((res) => {
        this.getSyncState();
      }).catch((err) => {
        this.syncLoading.close();
      });
    },
    getSyncState() {
      // 0：空闲，无抓取任务
      // 1：正在抓取中
      // 2：抓取已完成，成功
      // 3：抓取已中止，失败
      var interval = setInterval(() => {
        this.orderApi.syncStatus(this.mallToken).then((res) => {
          if (res.syncStatus != 1) {
            clearInterval(interval);
            this.showSync = false;
            this.syncLoading.close();
            if (res.syncStatus == 2) this.$message.success("抓取完成");
            if (res.syncStatus == 3) this.$message.error("抓取失败，已终止");
            //隐藏组件
            this.refresh = false;
            this.$nextTick(() => {
              //显示组件
              this.refresh = true;
            });
          }
        }).catch((err) => {
          clearInterval(interval);
          this.syncLoading.close();
        });
      }, 5000);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-head {
  position: fixed;
  z-index: 10;
  border-width: 0px;
  width: 100%;
  height: 64px;
  background-color: #001529;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  cursor: default;
  user-select: none;

  .title {
    font-weight: bold;
    width: 260px;
    text-align: center;
    line-height: 64px;
  }

  .menu {
    display: flex;
    align-items: center;
    width: calc(100% - 560px);

    .menu-item {
      width: 160px;
      text-align: center;
      line-height: 64px;
      cursor: pointer;
    }

    .active {
      background-color: #173551;
    }
  }

  .action {
    width: 300px;
    line-height: 64px;
    height: 100%;
    display: flex;
    justify-content: flex-end;

    .logo {
      width: 50px;
      display: flex;
      align-items: center;
      margin: unset;

      .el-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
  }
}

.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 64px);
  padding-top: 64px;
  // padding: 20px;
  width: 100%;
  position: relative;
  // overflow: hidden;
}

.text-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-info {
  color: #ffffff;
  max-width: 140px;
  min-width: 100px;
  text-align: center;
  cursor: pointer;
  padding: 0 5px;
}

.day {
  color: #f56c6c;
  margin-right: 5px;
}

.user-info-box {
  width: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  .user-info-item {
    padding: 0 5px;
    line-height: 28px;
  }

  .footer {
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 10px;
    border-top: 1px solid #dedede;
    padding-top: 10px;

    .btn {
      color: #409eff;
      cursor: pointer;
    }
  }
}
</style>
